import { SHORT_VIDEO_API } from '@/configs/api'
import { PLAYLIST_TYPE, SHORT_VIDEO_TRACKING_TYPE } from '@/configs/constants'
import { detectDevice, getCountryCode } from '@/helpers/index'
import httpResources from '@/libs/axios'
import { ORIENTATION_TYPE } from '@/configs/constants'
import { getPlaylistData } from '~/store/playlist'
import { STATUS_RESPONSES } from '~/configs/settings'
class GlobalSettings {
    constructor() {
        this.isUseNewTracking = false
        this.isLoaded = false
        this.httpInstance = httpResources
        this.getTrackingConfig()
        ;(this.overflowStyle = {
            bodyOverflow: '',
            documentOverflow: '',
        }),
            (this.countryCode = '')
        this.domainTracking = encodeURIComponent(window.location.href)
        this.device = ''
        this.orientationType = ORIENTATION_TYPE.PORTRAIT
        this.impressionTracking = {}
    }
    async getTrackingConfig() {
        if (this.httpInstance.repositories) {
            // try {
            // 	const { code, data } =
            // 		await this.httpInstance.repositories.setting.getTrackingSetting();
            // 	if (code === STATUS_RESPONSES.SUCCESS) {
            this.isLoaded = true
            this.isUseNewTracking = true
            // 	}
            // } catch (e) {
            // 	console.error(e);
            // }
        } else {
            setTimeout(async () => {
                await this.getTrackingConfig()
            }, 100)
        }
    }

    getGlobalStyle() {
        const bodyStyle = window.getComputedStyle(document.body)
        const documentStyle = window.getComputedStyle(document.documentElement)
        const bodyOverflow = bodyStyle.getPropertyValue('overflow')
        const documentOverflow = documentStyle.getPropertyValue('overflow')
        this.overflowStyle = { bodyOverflow, documentOverflow }
        return { bodyOverflow, documentOverflow }
    }

    getDevice() {
        if (!this.device) this.device = detectDevice()
        return this.device
    }

    async getCountry() {
        this.countryCode = await getCountryCode()
    }
    // Use for playlist videos (eg: Impression analytics)
    async trackingIOT(trackingType, playlistId, videoItems, tagName, orgId, ctaLink = '', productId = null) {
        const wrapper = tagName.toLowerCase()
        let playlistType = wrapper.toLowerCase().includes('carousel')
            ? PLAYLIST_TYPE.CAROUSEL
            : wrapper.includes('grid')
            ? PLAYLIST_TYPE.GRID
            : wrapper.includes('story-block')
            ? PLAYLIST_TYPE.STORY_BLOCK
            : ''
        const details = videoItems.map((item) => ({
            shortVideoId: item.id,
            type: trackingType,
            count: 1,
            trackedAt: Math.floor(Date.now() / 1000),
            duration: Number(item?.duration) || 0,
            ctaLink: ctaLink,
            countryCode: this.countryCode,
            productId: productId,
            uuid: item.uuid,
        }))

        const playlistData = getPlaylistData(playlistId)

        const trackingPayload = {
            playlistId,
            details,
            organizationId: Number(orgId) || playlistData?.data?.organizationId,
            playlistStoryType: Number(playlistType),
            device: this.device,
            domain: this.domainTracking,
        }

        if (this.httpInstance.repositories) {
            try {
                const { code } = await this.httpInstance.repositories.shortVideo.trackIOT(
                    SHORT_VIDEO_API.TRACK_IOT,
                    `${process.env.TRACKING_ENDPOINT}/api`,
                    trackingPayload
                )
                if (code === STATUS_RESPONSES.SUCCESS && trackingType === SHORT_VIDEO_TRACKING_TYPE.IMPRESSION) {
                    // Use forEach to iterate over details and update this.impressionTracking
                    details.forEach((detail) => {
                        let uuidTracking = `${detail.shortVideoId}_${detail.uuid}`
                        if (playlistId) {
                            uuidTracking += `_${playlistId}`
                        }
                        if (!this.impressionTracking[uuidTracking]) {
                            this.impressionTracking[uuidTracking] = true // Track the ID
                        }
                    })
                }
            } catch (e) {
                console.error(e)
            }
        }
    }
    getScreenOrientation() {
        this.orientationType = window.matchMedia('(orientation: landscape)').matches
            ? ORIENTATION_TYPE.LANDSCAPE
            : ORIENTATION_TYPE.PORTRAIT
    }
    checkScreenIsPortrait() {
        return this.orientationType === ORIENTATION_TYPE.PORTRAIT
    }

    isIdTracked(id) {
        return !!this.impressionTracking[id]
    }
}

export default new GlobalSettings()
